module.exports = __webpack_public_path__ + "assets/img/0217.d77f7891.png";